module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/avatars/female-2-b3a7fc814cf266c5de07839647759706.jpg";